export default __webpack_public_path__ + "static/button_spotify-b83bdd24af615bee672b0c8841aecbe7.png";